// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a6-0";
export var optionCard = "_a6-1";